const SCHOOL_TO_API_PROFILE = {
  "epita ia institut": "iaInstitut",
  "e-artsup": "eartsup",
  epita: "epita",
  esme: "esme",
  inge: "inge",
  ipsa: "ipsa",
  supbiotech: "supbiotech",
  supinfo: "supinfo",
  "iseg mcs": "iseg",
  "ionis stm": "ionistm",
  isg: "isg",
}

const DIVISION_TO_API_PROFILE = {
  "epita ia institut": "iaInstitut",
  "e-artsup": "eartsup",
  epita: "epita",
  esme: "esme",
  inge: "inge",
  ipsa: "ipsa",
  supbiotech: "supbiotech",
  supinfo: "supinfo",
  "iseg mcs": "iseg",
  iseg: "iseg",
  "ionis stm": "ionistm",
  "isg france": "isg",
  isg: "isg",
}

function normalizeKey(value) {
  return String(value || "").trim().toLowerCase()
}

function getProfileFromValue(value, source) {
  const normalized = normalizeKey(value)
  if (!normalized) return null
  return source[normalized] || null
}

export function resolveApiProfile({ apiProfile, school, division, lead } = {}) {
  if (apiProfile) return apiProfile

  const profileFromSchool = getProfileFromValue(school, SCHOOL_TO_API_PROFILE)
  if (profileFromSchool) return profileFromSchool

  const profileFromDivision = getProfileFromValue(division, DIVISION_TO_API_PROFILE)
  if (profileFromDivision) return profileFromDivision

  const profileFromLeadSchool = getProfileFromValue(lead?.IONISSchool__c, SCHOOL_TO_API_PROFILE)
  if (profileFromLeadSchool) return profileFromLeadSchool

  const profileFromLeadDivision = getProfileFromValue(lead?.Division__c, DIVISION_TO_API_PROFILE)
  if (profileFromLeadDivision) return profileFromLeadDivision

  return "default"
}

export const API_PROFILE_ENV_MAP = {
  iaInstitut: "REACT_APP_ENDPOINT_IA_INSTITUT",
  eartsup: "REACT_APP_ENDPOINT_EARTSUP",
  epita: "REACT_APP_ENDPOINT_EPITA",
  esme: "REACT_APP_ENDPOINT_ESME",
  inge: "REACT_APP_ENDPOINT_INGE",
  ipsa: "REACT_APP_ENDPOINT_IPSA",
  supbiotech: "REACT_APP_ENDPOINT_SUPBIOTECH",
  supinfo: "REACT_APP_ENDPOINT_SUPINFO",
  iseg: "REACT_APP_ENDPOINT_ISEG",
  ionistm: "REACT_APP_ENDPOINT_IONISTM",
  isg: "REACT_APP_ENDPOINT_ISG",
}
